import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import { NavLink } from "react-router-dom";
import SvgImage from "../../../Icons/Icons";
import "./index.css";
import moment from "moment";
import AddNewVendor from "../../../Vendor/Components/AddNewVendor";
import {
  getVendorLedger,
  clearVendorLedger,
} from "../../../../services/Store/Actions/TripsAction";
import { wait } from "@testing-library/user-event/dist/utils";
import NoTransaction from "../../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/TabularData/NoTransaction";
import { ClipLoader } from "react-spinners";
import { BallTriangle } from "react-loader-spinner";
import { cleanGetGpsComputedData, getGpsComputedDataAction } from "../../../../services/Store/Actions/fleetActions";
import CircularProgress from "@mui/material/CircularProgress";
import useScreenSize from "../../../core/screenSize";

function LocationTimeline(props) {
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [progress, setProgress] = useState(10);
  const screenSize = useScreenSize();

  const {
    vendorLedger,
    vendorLedgerList,
    tripLedgerLoader,
    vendorLedgerCount,
  } = useSelector((state) => state?.trip);

  const { gpsComputedVehicleData, gpsComputedVehicleDataLoader } = useSelector(
    (state) => state?.fleet
  );

  const { vendorData, path, setShowVendor } = props;
  //   const isLogipeVendor = path == "0" || path == "1" || path == "2" ? "1" : "0";

  const dispatch = useDispatch();
  console.log(
    "vendorTransactioffffnList",
    gpsComputedVehicleData,
    vendorLedger,
    vendorLedgerList
  );
  const handlePrev = () => {
    if (offset > 0) {
      //   dispatch(cleanVendorTransaction());
      dispatch(
        getGpsComputedDataAction(
          { vrn: props?.vrn, limit: 10, offset: offset - 10 },
          (res) => {
            console.log("mkjoijiojfre", res);
          }
        )
      );
      setOffset(offset - 10);
    }
  };

  // useEffect(() => {
  //   dispatch(
  //     getGpsComputedDataAction({ vrn: props?.vrn }, (res) => {
  //       console.log("mkjoijiojfre", res);
  //     })
  //   );
  //   return function cleanUp() {
  //     dispatch(cleanGetGpsComputedData());
  //   };
  // }, [props?.vrn]);
  const handleNext = () => {
    dispatch(
      getGpsComputedDataAction(
        { vrn: props?.vrn, limit: 10, offset: offset + 10 },
        (res) => {
          console.log("mkjoijiojfre", res);
        }
      )
    );
    setOffset(offset + 10);
  };
  return (
    <div
      className="vendorBg containerShadow"
      style={{ padding: 0, maxHeight: screenSize.height, overflowY: "scroll" }}
    >
      <div className="mt-0" style={{ position: "sticky" }}>
        {gpsComputedVehicleDataLoader ? (
          <div style={{ textAlign: "center", padding: "100% 0 0 0" }}>
            <CircularProgress />
          </div>
        ) : gpsComputedVehicleData?.length == 0 ?               <div className="greyFont heading3" style={{ marginTop: "10px",textAlign : "center" }}>
        There are no records to display
      </div> : (
          <>
            {gpsComputedVehicleData?.map((d, i) => {
              // const lastName_initials = d.lastName[0] + ".";

              let dif = moment.duration(
                moment(d?.toTime, "YYYY-MM-DD HH:mm:ss").diff(
                  moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss")
                )
              );
              let s =
                (dif?.days() ? dif?.days() + "d " : "") +
                (dif?.hours() ? dif?.hours() + "h " : "") +
                (dif?.minutes()
                  ? dif?.seconds()
                    ? parseFloat(dif?.minutes()) + 1 + "m "
                    : dif?.minutes() + "m "
                  : "");

              console.log("nkndfiniowe", s, i);

              return (
                <div
                  className={"div-table-row-gps row"}
                  style={{
                    border: "0.5px solid #E2E2E2",
                    borderRadius: "0.5rem",
                    margin: "0px 3px 0px",
                    boxShadow: " 0px 4px 20px 0px #25252d1a !important",
                    cursor: "pointer",
                  }}
                  //   onClick={() => handleClick(d, i)}
                  key={i}
                >
                  <div
                    className={`col-5 row ${
                      (d?.status == "STOPPED" ||  d?.status == "STOPED")
                        ? "vertical-line-red"
                        : "vertical-line"
                    }`}
                    style={{ padding: 0 }}
                  >
                    <div
                      className="d-flex flex-column"
                      style={{ padding: "6px 0 6px 10px" }}
                    >
                      <div className="FontNR12">
                        {" "}
                        {d?.toTime
                          ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss").format(
                              "HH:mm"
                            )
                          : moment(new Date()).format("HH:mm")}
                      </div>
                      <div className="FontNB8">
                        {" "}
                        {d?.toTime
                          ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss").format(
                              "DD/MM/YYYY"
                            )
                          : moment(new Date()).format("DD/MM/YYYY")}
                      </div>
                      <div
                        className="FontNB8"
                        style={{ padding: "10px 0 0 0" }}
                      >
                        {" "}
                        {d?.fromTime && d?.toTime
                          ? moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss").format(
                              "DD/MM/YYYY"
                            ) ==
                            moment(d?.toTime, "YYYY-MM-DD HH:mm:ss").format(
                              "DD/MM/YYYY"
                            )
                            ? ""
                            : moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss").format(
                                "DD/MM/YYYY"
                              )
                          : ""}
                      </div>
                      <div className="FontNR12">
                        {" "}
                        {d?.fromTime
                          ? moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss").format(
                              "HH:mm"
                            )
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-7 d-flex flex-column">
                    <div
                      className={"FontNS16"}
                      style={{
                        color: (d?.status == "STOPPED" || d?.status == "STOPED") ? "red" : "green",
                        padding: "5px 5px 0 5px",
                      }}
                    >
                      {(d?.status == "STOPPED"||  d?.status == "STOPED") ? "Stop" : "Moving"}
                    </div>
                    <div
                      className={"FontNM14 d-flex flex-column"}
                      style={{ padding: "0 0 0 5px" }}
                    >
                      <div>{s} </div>
                      {d?.status == "RUNNING" &&
                      parseFloat(d?.toOdometer || 0) -
                        parseFloat(d?.fromOdometer || 0) !=
                        "0" ? (
                        <div>
                          {(
                            parseFloat(d?.toOdometer || 0) -
                            parseFloat(d?.fromOdometer || 0)
                          )?.toFixed() < 0
                            ? "0"
                            : (
                                parseFloat(d?.toOdometer || 0) -
                                parseFloat(d?.fromOdometer || 0)
                              )?.toFixed()}{" "}
                          Km
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div
                      className={"FontNM14"}
                      style={{ padding: "0 0 0 5px", wordBreak: "normal" }}
                    >
                      {(d?.status == "STOPPED" ||  d?.status == "STOPED") ? d?.from : ""}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* {
          olderHistoryStatus?
          <div className="olderTransactions-div" onClick={handleOlderTransactions}>
          Older History
          </div>:
        <></>
        } */}

      </div>
      <div className="nextRow col-12" style={{textAlign : "center"}}>
        <div className="nextRowCont ">
          <button
            className="nextButton"
            onClick={handleNext}
            disabled={gpsComputedVehicleData?.length == 0}
            style={
              {
                //   opacity: gpsComputedVehicleData?.count - props.offset > 15 ? "1" : "0.5",
              }
            }
          >
            <SvgImage name="downArr" heigth="12px" width="12px" />
          </button>
        </div>
      </div>
    </div>
  );
}
export default LocationTimeline;
